import { OnsipAPIArray, onsipApiArrayToArray } from "../../apiResponse/xml-json";
import { parse as xmlParse } from "fast-xml-parser";

export declare interface ApiPrepaidTransaction {
  PrepaidTransactionId: string;
  PrepaidTransactionType: string;
  TransactionId: string;
  UserId: string;
  AccountId: string;
  Amount: string;
  Tax: string;
  TaxXml: string;
  Description: string;
  Modified: string;
}

export declare interface PrepaidTransaction {
  prepaidTransactionId: string;
  prepaidTransactionType: string;
  transactionId: string;
  userId: string;
  accountId: string;
  amount: string;
  tax: string;
  taxXml: Array<PrepaidTransactionTax>;
  description: string;
  modified: string;
}

export declare interface ApiPrepaidTransactionTax {
  TaxTypeCode: string;
  TaxTypeDesc: string;
  TaxableRevenue: string;
  TaxAmount: string;
  Units: string;
}

export declare interface PrepaidTransactionTax {
  taxTypeCode: string;
  taxTypeDesc: string;
  taxableRevenue: string;
  taxAmount: string;
  units: string;
}

export function ApiPrepaidTransactionToPrepaidTransaction(
  apiPrepaidTransaction: ApiPrepaidTransaction
): PrepaidTransaction {
  return {
    prepaidTransactionId: apiPrepaidTransaction.PrepaidTransactionId,
    prepaidTransactionType: apiPrepaidTransaction.PrepaidTransactionType,
    transactionId: apiPrepaidTransaction.TransactionId,
    userId: apiPrepaidTransaction.UserId,
    accountId: apiPrepaidTransaction.AccountId,
    amount: apiPrepaidTransaction.Amount,
    tax: apiPrepaidTransaction.Tax,
    taxXml: apiPrepaidTransactionTaxToPrepaidTransactionTax(
      xmlToJson(apiPrepaidTransaction.TaxXml)
    ),
    description: apiPrepaidTransaction.Description,
    modified: apiPrepaidTransaction.Modified
  };
}

export function apiPrepaidTransactionTaxToPrepaidTransactionTax(apiPrepaidTax: {
  TaxItems?: OnsipAPIArray<"TaxItem", ApiPrepaidTransactionTax>;
}): Array<PrepaidTransactionTax> {
  const taxItems = apiPrepaidTax.TaxItems;
  if (!taxItems) return [];
  return onsipApiArrayToArray(taxItems, "TaxItem").map(taxItem => {
    return {
      taxTypeCode: taxItem.TaxTypeCode,
      taxTypeDesc: taxItem.TaxTypeDesc,
      taxableRevenue: taxItem.TaxableRevenue,
      taxAmount: taxItem.TaxAmount,
      units: taxItem.Units
    } as PrepaidTransactionTax;
  });
}

function xmlToJson(xml: string) {
  const data = xmlParse(xml);
  return data;
}
